import { render, staticRenderFns } from "./ComplaintGalleryList.vue?vue&type=template&id=3e23dfd0&scoped=true"
import script from "./ComplaintGalleryList.vue?vue&type=script&lang=js"
export * from "./ComplaintGalleryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e23dfd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e23dfd0')) {
      api.createRecord('3e23dfd0', component.options)
    } else {
      api.reload('3e23dfd0', component.options)
    }
    module.hot.accept("./ComplaintGalleryList.vue?vue&type=template&id=3e23dfd0&scoped=true", function () {
      api.rerender('3e23dfd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/circle/complaint/ComplaintGalleryList.vue"
export default component.exports